import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ConnectDomainMutation } from "../graphql/mutations";
import type {
  ConnectDomainMutationType,
  ConnectDomainMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useConnectDomainMutation = (
  options?: MutationHookOptions<
    ConnectDomainMutationType,
    ConnectDomainMutationVariablesType
  >
) => {
  return useMutation<
    ConnectDomainMutationType,
    ConnectDomainMutationVariablesType
  >(ConnectDomainMutation, options);
};
